module.exports = __webpack_public_path__ + "static/media/S4N6-5.89296909.svg";